import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Mohammad Khamis</h4>
            <p>Technical Manager & Full Stack Developer</p>
            <p>Passionate about building scalable systems and leading AI transformation initiatives.</p>
          </div>
          
          <div className="footer-section">
            <h5>Quick Links</h5>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#experience">Experience</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h5>Technologies</h5>
            <ul>
              <li>Node.js & TypeScript</li>
              <li>AWS Cloud Services</li>
              <li>MongoDB & Elasticsearch</li>
              <li>AI & Machine Learning</li>
              <li>DevOps & CI/CD</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h5>Connect</h5>
            <div className="footer-contact">
              <p>📧 m@khamis.info</p>
              <p>📱 +962 7887 515 38</p>
              <p>🌍 Amman, Jordan</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-copyright">
            <p>&copy; {currentYear} Mohammad Khamis. All rights reserved.</p>
            <p className="footer-note">
              Built with React & TypeScript • From Basic to Node.js, the journey continues
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
